import { QuoteClientEmailDetails } from "./client-email-details.model";
import { QuoteEmailAttachmentMapper } from "./email-attachment.mapper";

export class QuoteClientEmailDetailsMapper {
  public static map(data: any): QuoteClientEmailDetails {
    if (!data) {
      return null;
    }

    return new QuoteClientEmailDetails(
      data.clientEmail ?? null,
      data.clientSubject ?? null,
      data.clientBody ?? null,
      data.salesEmail ?? null,
      QuoteEmailAttachmentMapper.mapAll(data.attachments),
    );
  }
}
